import { formatAda, lovelaceToAda } from '@src/utils/dRepUtils';
import cn from 'classnames';
import Info from '@src/components/icons/info';
import CustomizeToolTip from '@src/components/atoms/tooltip';
import {
  calculateThreshold,
  getTextAndBackgroundColor,
} from '@src/utils/governanceActionUtils';
import ProgressIndicator from '@src/components/atoms/progressIndicator';
import type { VotedType, Voter } from '@src/models/types';
import type { IVoteResponse } from '@src/models/dtos';

interface IVoteCard {
  voter: Voter;
  voteResponse: IVoteResponse;
  threshold?: number | null;
}
export default function VotedCard({
  voter,
  voteResponse,
  threshold,
}: IVoteCard) {
  function VotedItem({
    type,
    value,
    percentage,
  }: {
    type: VotedType;
    value: string | number;
    percentage: number;
  }) {
    const { textColor, backgroundColor } = getTextAndBackgroundColor(type);
    const isYesOrNoType = type === 'Yes' || type === 'No';
    return (
      <div className="flex flex-col gap-1">
        <p className="body14 flex items-center gap-1 text-gray-400">
          {isYesOrNoType && <span>Voted</span>}
          <span className={cn(isYesOrNoType && 'font-bold text-white')}>
            {isYesOrNoType ? `“${type}”` : type}
          </span>
        </p>

        <ProgressIndicator
          backgroundColor={backgroundColor}
          textColor={textColor}
          progress={percentage}
          totalValue={value}
        />
      </div>
    );
  }

  return (
    <div>
      <div className="rounded-lg border dark:border-dark-neutral-700 dark:bg-dark-neutral-900 sm:min-w-[288px]">
        <div className="body18 flex h-[51px] justify-between rounded-t-lg border-b px-4 py-3 dark:border-dark-neutral-700 dark:bg-dark-neutral-800 dark:text-white">
          <p className="font-semibold">{voter}</p>
          {threshold && (
            <div className="flex items-center gap-1">
              <p className="font-semibold">{threshold * 100}%</p>
              <Info
                className="z-20 cursor-pointer"
                data-tooltip-place="bottom-end"
                data-tooltip-id={voter + 'ratification'}
              />
              <CustomizeToolTip
                id={voter + 'ratification'}
                description="Ratification Threshold"
              />
            </div>
          )}
        </div>

        <div className="flex flex-col gap-2 px-4 py-3">
          {['Yes', 'No', 'Abstained', 'Not Voted'].map((type) => (
            <VotedItem
              key={type}
              type={type as VotedType}
              value={
                voter !== 'CC'
                  ? `₳ ${formatAda(lovelaceToAda(voteResponse[type as keyof IVoteResponse]))}`
                  : voteResponse[type as keyof IVoteResponse]
              }
              percentage={calculateThreshold(
                voteResponse,
                voteResponse[type as keyof IVoteResponse]
              )}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
